// extracted by mini-css-extract-plugin
export var footer = "_pv-0";
export var inherit = "_pv-1";
export var input = "_pv-2";
export var modalContent = "_pv-3";
export var quillEditor = "_pv-4";
export var subtitle = "_pv-5";